import { render } from "./SupplyDemandTable.vue?vue&type=template&id=05a3b223"
import script from "./SupplyDemandTable.vue?vue&type=script&lang=js"
export * from "./SupplyDemandTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__